// extracted by mini-css-extract-plugin
export default {"modal-body":"modal-body-MenHyYB","loading-wrapper":"loading-wrapper-rPcf1is"};